import { render, staticRenderFns } from "./PrimaryForm.vue?vue&type=template&id=cc12b6c4&scoped=true"
import script from "./PrimaryForm.vue?vue&type=script&lang=ts"
export * from "./PrimaryForm.vue?vue&type=script&lang=ts"
import style0 from "./PrimaryForm.vue?vue&type=style&index=0&id=cc12b6c4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc12b6c4",
  null
  
)

export default component.exports